import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store/reducer';

export const selectMfa = (state: RootState): RootState['mfa'] => state.mfa;

export const selectMfaUserId = createSelector(selectMfa, (mfa) => mfa.mfaUserId);

export const selectMfaService = createSelector(selectMfa, (mfa) => mfa.service);

export const selectMfaDialogOpen = createSelector(selectMfa, (mfa) => mfa.dialogOpen);

export const selectMfaDialogState = createSelector(selectMfa, (mfa) => mfa.dialogState);

export const selectMfaErrorMessage = createSelector(selectMfa, (mfa) => mfa.errorMessage);

export const selectMfaActionType = createSelector(selectMfa, (mfa) => mfa.actionType);
